export default __webpack_public_path__ + "static/media/layout.12ff3d33.jpg";